class Debug{
  isDev=()=> {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      // dev code
      return true
    } else {
      // production code
      return false
    }
  }
  runInDevENV=(callback)=>{
    if(this.isDev()){
      return callback
    }else{
      return ()=>{}
    }
  }

  // debug printing 
  print = this.runInDevENV((...data)=>console.log(...data))

  log = this.runInDevENV((...data)=>console.log(...data))

  error = this.runInDevENV((...data)=>console.error(...data))
}

export default new Debug()

